<h2 mat-dialog-title>Crear partido</h2>

<mat-dialog-content>
  <form [formGroup]="form" id="createMatchForm" (ngSubmit)="submit()">

    <!-- Categoría + Grupo -->
    <div class="field-row">
      <mat-form-field appearance="fill">
        <mat-label>Categoría</mat-label>
        <input matInput formControlName="category" />
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Grupo</mat-label>
        <input matInput formControlName="groupName" />
      </mat-form-field>
    </div>

    <!-- Fecha + Hora -->
    <div class="field-row">
      <mat-form-field appearance="fill">
        <mat-label>Fecha</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date" />
        <mat-datepicker-toggle matSuffix [for]="picker" />
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Hora</mat-label>
        <input matInput type="time" formControlName="time" />
      </mat-form-field>
    </div>

    <!-- Jugadores -->
    <div class="field-row">
      <mat-form-field appearance="fill">
        <mat-label>Jugador 1</mat-label>
        <input matInput formControlName="player1Id" />
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Jugador 2</mat-label>
        <input matInput formControlName="player2Id" />
      </mat-form-field>
    </div>

    <!-- Cancha -->
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Cancha</mat-label>
      <input matInput formControlName="court" />
    </mat-form-field>

    <!-- Formato + Puntos -->
    <div class="field-row">
      <mat-form-field appearance="fill">
        <mat-label>Formato</mat-label>
        <mat-select formControlName="bestOf">
          <mat-option [value]="3">Mejor de 3</mat-option>
          <mat-option [value]="5">Mejor de 5</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Puntos por juego</mat-label>
        <input matInput type="number" formControlName="pointsToWin" min="1" />
      </mat-form-field>
    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="exit()">Cancelar</button>
  <button mat-flat-button color="primary" type="submit" form="createMatchForm" [disabled]="form.invalid">
    Guardar
  </button>
</mat-dialog-actions>
